import React, {useState} from 'react';

export function InputRadioFilter({type = 'radio', text, name, count, value, checked, disabled, onChange}) {
  const [emptyValue] = useState(typeof value === "boolean" ? false : '');
  return <label htmlFor={name + "_" + value} className="filter-checkbox">
    <input type={type}
           id={name + "_" + value}
           name={type === 'radio' ? name : name + "_" + value}
           checked={checked}
           className="filter-checkbox__input"
           disabled={disabled}
           onChange={(e) => onChange(name, type === 'radio' ? value : (e.target.checked ? value : emptyValue))} />
    <span className="filter-checkbox__icon"></span>
    <span className="filter-checkbox__help">{text}</span>
    <span className="filter-checkbox__value">{count}</span>
  </label>;
}
